import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import { isEmpty, uniq, get } from 'lodash';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from '@material-ui/core/Tooltip';

import toRenderProps from 'recompose/toRenderProps';
import withState from 'recompose/withState';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import EsmsPage from '../../components/EsmsPage';
import InviteUserModal from '../Modals/InviteUserModal';
import ManageUserModal from '../Modals/ManageUserModal';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import classes from './UsersPage.module.css';

import * as AdminActions from '../../actions/adminActions';
import * as DashboardActions from '../../actions/dashboardActions';
import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as CoreActions from '../../actions/coreActions';

const WithState = toRenderProps(withState('anchorEl', 'updateAnchorEl', null));

class UsersPage extends Component {
    state = {
        inviteModalOpen:     false,
        manageUserModalOpen: false,
        order:               'asc',
        orderBy:             'email',
        user:                {},
        users:               [],
    }

    async componentDidMount() {
        let { companyInfo, updateUsers, setProgressBarLoading } = this.props;

        setProgressBarLoading(true);

        if (companyInfo.companyId) {
            await this.prepareUsers(companyInfo, updateUsers);
        }

        setProgressBarLoading(false);
    }

    componentDidUpdate(prevProps) {
        let { companyInfo, updateUsers, users } = this.props;

        if (prevProps.companyInfo !== companyInfo) {
            this.prepareUsers(companyInfo, updateUsers);
        }

        if (prevProps.users !== users) {
            this.setState({ users });
        }
    }

    prepareUsers = async (companyInfo, updateUsers) => {
        try {
            await updateUsers(companyInfo.companyId);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log('error caught: ', error);
        }
    }

    inviteUser = async user => {
        const { createAccount, companyInfo, updateUsers } = this.props;

        const roleId = get(user, 'role', '');

        const body = {
            email: get(user, 'email', '')
        };

        const isInvited = await createAccount(roleId, body);

        if (isInvited) {
            await updateUsers(companyInfo.companyId);

            return true;
        }

        return false;
    }

    updateUser = async role => {
        if (this.isTheOnlyAdminAccount()) {
            this.props.enqueueSnackbar('At least one Admin account must exist.', 'error');

            return;
        }

        const { updateAccount, companyInfo, updateUsers } = this.props;

        const roleId = get(role, 'role');

        const body = {
            email: this.state.user.email
        };

        const isUpdated = await updateAccount(roleId, body);

        if (isUpdated) {
            await updateUsers(companyInfo.companyId);

            return true;
        }

        return false;
    }

    isTheOnlyAdminAccount = (user = {}) => {
        const targetUser = isEmpty(user) ? this.state.user : user;

        const allAdmins = this.props.users
            .filter(user => !isEmpty(user.role))
            .filter(user => user.role.name.toLowerCase() === 'admin');
        const isAnAdmin = allAdmins.filter(admin => admin.id === targetUser.id);

        return allAdmins.length === 1 && isAnAdmin.length === 1;
    }

    handleManageUser = user => {
        this.setState(state => ({
            manageUserModalOpen: true,
            user
        }));
    }

    handleRemoveUser = async user => {
        let { companyInfo, deleteAccount, updateUsers, setProgressBarLoading } = this.props;

        setProgressBarLoading(true);

        const accountId = get(user, 'id', '');
        const roleId = get(user, 'role.id', '');

        if (this.isTheOnlyAdminAccount(user)) {
            this.props.enqueueSnackbar('At least one Admin account must exist.', 'error');

            return;
        }

        if (isEmpty(roleId) || isEmpty(accountId)) {
            this.props.enqueueSnackbar('Unexpected failure, cannot remove User.', 'error');

            return;
        }

        const isDeleted = await deleteAccount(roleId, accountId);

        if (isDeleted) {
            await updateUsers(companyInfo.companyId);
        }
        setProgressBarLoading(false);
    }

    handleResendInvite = async user => {
        let { companyInfo, resendInvitation, updateUsers } = this.props;

        const body = {
            email: user.email
        };
        const roleId = get(user, 'role.id', '');

        if (isEmpty(roleId)) {
            this.props.enqueueSnackbar('Unexpected failure, cannot re-invite User.', 'error');

            return;
        }

        const isReinvited = await resendInvitation(roleId, body);

        if (isReinvited) {
            await updateUsers(companyInfo.companyId);
        }
    }

    handleToggleInviteModal = () => {
        this.setState(state => ({
            inviteModalOpen: !state.inviteModalOpen
        }));
    }

    handleCloseManageUserModal = () => {
        this.setState(state => ({
            manageUserModalOpen: false
        }));
    }

    handleSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    }

    handlePageRoute = () => {
        const { history } = this.props;

        history.push('/admin' + history.location.search);
    }

    handleSearch = searchTerm => {
        const { users } = this.props;
        let firstNames, lastNames, emails, status, filteredUsers;

        if (isEmpty(searchTerm)) {
            this.setState({ users });
        } else {
            const normalizeSearchTerm = searchTerm.toLowerCase();

            firstNames = users
                .filter(user => !isEmpty(user.firstName))
                .filter(user => user.firstName.toLowerCase().includes(normalizeSearchTerm));
            lastNames = users
                .filter(user => !isEmpty(user.lastName))
                .filter(user => user.lastName.includes(normalizeSearchTerm));
            emails = users
                .filter(user => !isEmpty(user.email))
                .filter(user => user.email.includes(normalizeSearchTerm));
            status = users
                .filter(user => !isEmpty(user.status))
                .filter(user => user.status.includes(normalizeSearchTerm));

            filteredUsers = [...firstNames, ...lastNames, ...emails, ...status];

            this.setState({ users: uniq(filteredUsers) });
        }
    }

    stableSort = (array, cmp) => {
        const stabilizedThis = array.map((el, index) => [el, index]);

        stabilizedThis.sort((a, b) => {
            const order = cmp(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });

        return stabilizedThis.map(el => el[0]);
    }

    getSorting = (order, orderBy) => {
        if (order === 'desc') {
            return (a, b) => this.desc(a, b, orderBy);
        }

        return (a, b) => -this.desc(a, b, orderBy);
    }

    desc = (a, b, orderBy) => {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }

        return 0;
    }

    rowMenu = user => {
        return (
            <WithState>
                {({ anchorEl, updateAnchorEl }) => {
                    const open = Boolean(anchorEl);
                    const handleClose = () => {
                        updateAnchorEl(null);
                    };

                    return (
                        <React.Fragment>
                            <Button
                                aria-owns={open ? 'render-props-menu' : undefined}
                                aria-haspopup="true"
                                onClick={event => {
                                    updateAnchorEl(event.currentTarget);
                                }}
                                className={classes.contextMenuButton}
                            >
                                <i className="fas fa-ellipsis-h" />
                            </Button>
                            <Menu
                                id="render-props-menu"
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                className={classes.contextMenu}
                            >
                                {
                                    user.status === 'invited' &&
                                    <MenuItem
                                        onClick={e => {
                                            this.handleResendInvite(user);
                                            handleClose();
                                        }}
                                    >
                                        <img
                                            className={classes.contextIcon}
                                            src="/assets/images/resendInviteIconColor.svg" alt="resend invitation"
                                        />
                                        Resend Invitation
                                    </MenuItem>
                                }
                                <MenuItem
                                    onClick={e => {
                                        this.handleManageUser(user);
                                        handleClose();
                                    }}
                                >
                                    <img
                                        className={classes.contextIcon}
                                        src="/assets/images/SettingsFlat.svg" alt="manage user"
                                    />
                                    Manage User
                                </MenuItem>
                                <MenuItem
                                    onClick={e => {
                                        this.handleRemoveUser(user);
                                        handleClose();
                                    }}
                                >
                                    <img
                                        className={classes.contextIcon}
                                        src="/assets/images/deleteIconColor.svg" alt="remove user"
                                    />
                                    Remove User
                                </MenuItem>
                            </Menu>
                        </React.Fragment>
                    );
                }}
            </WithState>
        );
    }

    render() {
        let { companyInfo, currentScopes } = this.props;
        let { order, orderBy, users } = this.state;

        return (
            <React.Fragment>
                <EsmsPage
                    parents={[companyInfo.companyName]}
                    handlers={[this.handlePageRoute]}
                    title="Users"
                >
                    <ActionBar
                        onSearch={this.handleSearch}
                    >
                        <ActionBarItem
                            hidden={!isAllowed(currentScopes, Permissions('adminFull'))}
                            onClick={this.handleToggleInviteModal}
                            type="add"
                        >
                            Invite User
                        </ActionBarItem>
                    </ActionBar>
                    <div className={classes.userPageContents}>
                        <div className={classes.scrollTable}>
                            <Table 
                                className={classes.userTable}
                                options={{
                                    maxBodyHeight: '300px'
                                }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            className={classes.headerCell}
                                            sortDirection={orderBy === 'email' ? order : false}
                                            onClick={event => this.handleSort(event, 'email')}
                                        >
                                            <Tooltip
                                                title={
                                                    <React.Fragment>
                                                        <span className={classes.tooltip}>Sort</span>
                                                    </React.Fragment>
                                                }
                                                placement="top-start"
                                            >
                                                <TableSortLabel
                                                    active={orderBy === 'email'}
                                                    direction={order}
                                                >
                                                    Email
                                                </TableSortLabel>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell className={classes.headerCell}>Role</TableCell>
                                        <TableCell
                                            className={classes.headerCell}
                                            sortDirection={orderBy === 'firstName' ? order : false}
                                            onClick={event => this.handleSort(event, 'firstName')}
                                        >
                                            <Tooltip
                                                title={
                                                    <React.Fragment>
                                                        <span className={classes.tooltip}>Sort</span>
                                                    </React.Fragment>
                                                }
                                                placement="top-start"
                                            >
                                                <TableSortLabel
                                                    active={orderBy === 'firstName'}
                                                    direction={order}
                                                >
                                                    Full Name
                                                </TableSortLabel>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell
                                            className={classes.headerCell}
                                            sortDirection={orderBy === 'status' ? order : false}
                                            onClick={event => this.handleSort(event, 'status')}
                                        >
                                            <Tooltip
                                                title={
                                                    <React.Fragment>
                                                        <span className={classes.tooltip}>Sort</span>
                                                    </React.Fragment>
                                                }
                                                placement="top-start"
                                            >
                                                <TableSortLabel
                                                    active={orderBy === 'status'}
                                                    direction={order}
                                                >
                                                    Status
                                                </TableSortLabel>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell className={classes.contextHeaderCell} />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { this.stableSort(users, this.getSorting(order, orderBy))
                                        .map(user =>
                                            <TableRow key={user.id}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                    className={`${classes.dataCell} ${classes.emailCell}`}
                                                >
                                                    {user.email}
                                                </TableCell>
                                                <TableCell className={classes.dataCell}>{user.role ? user.role.name : ''}</TableCell>
                                                <TableCell className={classes.dataCell}>
                                                    {user.firstName ? `${user.firstName} ${user.lastName}` : ''}
                                                </TableCell>
                                                <TableCell className={`${classes.dataCell} ${classes.statusCell}`}>{user.status}</TableCell>
                                                <TableCell className={`${classes.dataCell} ${classes.rowMenuCell}`}>
                                                    {
                                                        isAllowed(currentScopes, Permissions('adminFull')) &&
                                                        this.rowMenu(user)
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )}
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </EsmsPage>
                <InviteUserModal
                    open={this.state.inviteModalOpen}
                    close={this.handleToggleInviteModal}
                    create={this.inviteUser}
                    data={this.props.companyInfo}
                    title="Invite User"
                />
                <ManageUserModal
                    open={this.state.manageUserModalOpen}
                    close={this.handleCloseManageUserModal}
                    update={this.updateUser}
                    data={this.props.companyInfo}
                    user={this.state.user}
                    title={`Manage User: ${this.state.user.email}`}
                />
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:   state.companyInfo,
        currentScopes: state.core.currentScopes
    };
};

const mapDispatchToProps = {
    ...AdminActions,
    ...ApplicationMessageActions,
    ...CoreActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UsersPage));
